import { Stack, TextField } from "@mui/material";
import type { NumberFormatterOptions } from "../../../../../../../../../../../api/types/fieldConfigurationTypes.ts";

interface Props {
  formatOptions: NumberFormatterOptions | undefined;
  applyFormat: (formatOptions: NumberFormatterOptions) => void;
}
//TODO: Think about using https://mui.com/material-ui/react-number-field/
export const Decimals = ({ formatOptions, applyFormat }: Props) => {
  const changeDecimals = (value: string) => {
    const parsed = parseInt(value);
    if (isNaN(parsed)) {
      return;
    }
    const decimals = Math.min(10, Math.max(0, parsed));
    const copiedObject = {
      ...formatOptions,
      decimals,
    } as NumberFormatterOptions;
    applyFormat(copiedObject);
  };

  return (
    <Stack direction={"row"} sx={{ flex: 1, gap: 2 }}>
      <TextField
        value={formatOptions?.decimals || 0}
        type="number"
        label="Decimals"
        disabled={formatOptions?.autoDecimals === true}
        sx={{ flex: 1, fieldset: { borderColor: "divider" } }}
        slotProps={{
          htmlInput: {
            min: 0,
            max: 10,
            style: {},
          },
          inputLabel: {
            shrink: true,
          },
        }}
        onChange={(evt) => changeDecimals(evt.target.value)}
      />
    </Stack>
  );
};

export default Decimals;
